import "./columnSortIcon.css";
import PropTypes from "prop-types";

/* Paths are inset by half the stroke width so the glyph centers inside its button. */
const CHEVRON_UP = "M1.4 4.1L5 0.9L8.6 4.1";
const CHEVRON_DOWN = "M1.4 0.9L5 4.1L8.6 0.9";

function Chevron({ d }) {
  return (
    <svg
      className="agentic-sort-chevron"
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d={d}
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Chevron.propTypes = {
  d: PropTypes.string.isRequired,
};

/**
 * Stacked up/down sort chevrons with normal, hover and selected states.
 *
 * @param {"asc"|"desc"|null|undefined} direction currently applied sort for the column
 * @param {(direction: "asc"|"desc") => void} [onSort] when omitted, clicks bubble to the header cell
 */
export default function ColumnSortIcon({ className, direction = null, onSort }) {
  const active = direction === "asc" || direction === "desc";

  const handleClick = (nextDirection) => (event) => {
    if (typeof onSort !== "function") return;
    event.stopPropagation();
    onSort(nextDirection);
  };

  const buttonClass = (buttonDirection) => {
    const selected = direction === buttonDirection;
    return [
      "agentic-sort-btn",
      selected ? "agentic-sort-btn--selected" : "",
      active && !selected ? "agentic-sort-btn--dimmed" : "",
    ]
      .filter(Boolean)
      .join(" ");
  };

  const classNameSuffix = className ? ` ${className}` : "";
  return (
    <span className={`agentic-sort${classNameSuffix}`}>
      <button
        type="button"
        className={buttonClass("asc")}
        onClick={handleClick("asc")}
        title="Sort ascending"
        aria-label="Sort ascending"
        aria-pressed={direction === "asc"}
      >
        <Chevron d={CHEVRON_UP} />
      </button>
      <button
        type="button"
        className={buttonClass("desc")}
        onClick={handleClick("desc")}
        title="Sort descending"
        aria-label="Sort descending"
        aria-pressed={direction === "desc"}
      >
        <Chevron d={CHEVRON_DOWN} />
      </button>
    </span>
  );
}

ColumnSortIcon.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(["asc", "desc"]),
  onSort: PropTypes.func,
};